<template>
  <div>
     <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="30"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                :disabled="selectedRows.length > 0"
                class="ml-0"
              >
                <v-icon size="30"> mdi-file-plus-outline </v-icon>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-1"
              >
                <v-icon size="30"> mdi-clipboard-edit-outline </v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled
              class="ml-1">
                <v-icon size="30"> mdi-eye-outline </v-icon>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                @click="delete_dialog = true"
                class="ml-1"
              >
                <v-icon size="30"> mdi-delete-outline </v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="6">
           <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setData({key : 'selected_alphabet',value : ''})" icon small dark v-bind="attrs" v-on="on" class="">
                 <v-badge overlap dot :value="search" color="error">
                  <v-icon size="30">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="300">
              <v-row no-gutters>
            <v-col cols="12" class="">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                solo
                clearable
                v-on:keyup.enter="search_menu = false"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
            </v-card>
           </v-menu>
           <v-menu bottom :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" disabled class="ml-1">
                <v-icon>mdi-filter-menu-outline</v-icon>
              </v-btn>
            </template>
           </v-menu>
        </v-col>
        <v-col cols="2" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Cabinet Line</span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
          <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
        </v-overlay>
    <v-card flat tile>
      
      <v-card-text
        class="pa-0 mx-auto"
      >
        <v-row dense="" class="pa-0 ma-0">
          <v-col cols="1" class="pa-0 ma-0" style="max-width: 2.5%;">
            <AlphabetSort />
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table small-table fix-table-layout fix-table-header custom-width-550"
              item-key="user_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td width="3%">
                    <v-icon @click="editRecord(item.cabinet_line_id)">
                      mdi-clipboard-edit-outline
                    </v-icon>
                  </td>
                  <td width="7%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td width="86%">
                    {{item.name}}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Add Cabinet Line</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-text-field
                label="Name*"
                v-model="form_data.name"
                :error-messages="form_error.name"
                :hide-details="!form_error.name"
              ></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="dialog = false;form_data = {};form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addRecord"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Update Cabinet Line</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-text-field
                label="Name*"
                v-model="edit_form_data.name"
                :error-messages="edit_form_error.name"
                :hide-details="!edit_form_error.name"
              ></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error"
            @click="edit_dialog = false;edit_form_data = {};edit_form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateRecord" dark> Update </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirmation </v-card-title>
        <v-card-text>
          Are you sure you want to delete selected cabinet lines?
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteRecords()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, getAlphabets } from "../../plugins/helper";
import AlphabetSort from "../AlphabetSort";
import { mapState,mapMutations } from "vuex";
export default {
  name: "CabinetLine",
  data() {
    return {
      dialog: false,
      edit_dialog:false,
      delete_dialog: false,
      form_data: {},
      form_error: {},
      edit_form_data: {},
      edit_form_error: {},
      search: "",
      cabinet_line_id: null,
      form_loading:false,
      loading: false,
      items: {
        data: [],
      },
      headers: [
        { value: "", text: "", sortable: false, class:'pl-3', width: '7%' },
        { value: "checkbox", text: "#", sortable: false, width: '7%' },
        { value: "name", text: "Name", sortable: false, width: '86%' },
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["name"],
        page: 1,
        filters: {
          alphabet: "",
        },
      },
      alphabets: getAlphabets(),
      expanded: [],
      search_menu : false
    };
  },
  components: {
    AlphabetSort
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("submenu", ["selected_alphabet"]),
    selectedRows() {
      return this.items.data.filter(function (item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "name";
      return paginationData;
    },
  },
  watch: {
    selected_alphabet(val) {
      this.pagination.filters.alphabet = val
    },
    search() {
      this.getRecords();
    },
    pagination: {
      handler: function () {
        this.getRecords();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("submenu", ["setData"]),
    editRecord(cabinet_line_id) {
      this.cabinet_line_id = cabinet_line_id;
      this.edit_dialog=true;
      this.getDetails(cabinet_line_id)
    },
    expandRow(itemData) {
      if(itemData.value) {
        this.items.data = this.items.data.map(function(item){
          if(item.user_id == itemData.item.user_id) {
            item.selected = true
          }
          return item
        })
      }
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getRecords() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios.get("cabinet_line_list?" + url)
        .then((response) => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
           _self.setData({key : 'alphabets',value : response.data.alphabets})
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    addRecord() {
      let _self = this;
      _self.form_loading = true;
      axios.post("add_cabinet_line", _self.form_data)
        .then((response) => {
          _self.form_data = {};
          _self.form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.form_loading = false;
            _self.dialog = false
            _self.getRecords()
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    updateRecord(){
      let _self = this;
      _self.edit_form_data.cabinet_line_id = _self.cabinet_line_id
      axios.post("update_cabinet_line", _self.edit_form_data)
        .then((response) => {
          _self.edit_form_data = {};
          _self.edit_form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.edit_form_error[key] = data.errors[key][0];
            }
          } else {
            _self.edit_form_data = {}
            _self.form_loading = false;
            _self.edit_dialog = false
            _self.getRecords();
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    getDetails(cabinet_line_id){
      let _self = this
      _self.form_loading= true;
      axios.get("get_cabinet_line_details?cabinet_line_id="+cabinet_line_id)
        .then((response) => {
          _self.edit_form_data.name = response.data.data.name;
          _self.form_loading = false;
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    deleteRecords(){
      let _self = this
      let ids = []
      this.selectedRows.map(function(item){
        ids.push(item.cabinet_line_id)
      })
      axios.post("delete_cabinet_lines",{
        ids : ids
      }).then(function(){
        _self.getRecords()
      })
      .catch(function(){
        console.log('FAILURE!!');
      });
    },
  },
  mounted() {
    this.getRecords();
  },
};
</script>